import { DatePicker, Empty, Input, Table, Tag, message } from "antd";
import dayjs from "dayjs";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { MakeApiCall } from "../../../../apis";
import InfoVideo from "../../../../components/header-icons";
import Pagination from "../../../../components/pagination";
import { TableLoading } from "../../../../components/table-animation";
import ExportFile from "./export-file";
import { ErrorModal } from "../../../../components/upload-modals";
import { RenderTable } from "../../../../config";
dayjs.extend(quarterOfYear);
const AsinPerformance = ({ locationData }) => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  const [tableLoading, setTableLoading] = useState(true);
  const [totalPage, setTotalPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [page, setPage] = useState(1);
  const [sortFilters, setSortFilters] = useState({
    field_name: "sales_date",
    sort_by: "desc",
  });
  const [filters, setFilters] = useState({
    search_key: null,
    start_date: dayjs().startOf("month").format("YYYY-MM-DD"),
    end_date: dayjs().endOf("month").format("YYYY-MM-DD"),
  });
  const CommaAndFloat = (e) => {
    return (e || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };
  const Comma = (e) => {
    return (e || 0).toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };

  const columns = [
    {
      title: "Sales Date",
      dataIndex: "sales_date",
      key: "sales_date",
    },
    {
      title: "Parent ASIN",
      dataIndex: "parent_asin",
      key: "parent_asin",

      render: (e) => {
        return <Tag color="blue-inverse">{e || "-"}</Tag>;
      },
    },
    {
      title: "Child ASIN",
      dataIndex: "child_asin",
      key: "child_asin",

      render: (e) => {
        return <Tag color="blue">{e || "-"}</Tag>;
      },
    },
    {
      title: "SKU",
      dataIndex: "sku",
      key: "sku",

      render: (e) => {
        return <Tag color="magenta">{e || "-"}</Tag>;
      },
    },
    {
      title: "Item Title",
      dataIndex: "title",
      width: 400,
      key: "title",
    },
    // {
    //   title: "Units Sold",
    //   dataIndex: "units_ordered",
    //   key: "units_ordered",
    // },

    {
      title: "USP (%)",
      dataIndex: "unit_session_percentage",
      align: "right",
      key: "unit_session_percentage",
    },
    {
      title: "Click to Sales (%)",
      align: "right",
      dataIndex: "click_to_sales_pect",
      key: "click_to_sales_pect",
    },
    {
      title: "Browser Session Rate",
      dataIndex: "browser_session_rate",
      key: "browser_session_rate",
      align: "right",
    },
    {
      title: "Browser Page View Rate",
      dataIndex: "browser_page_view_rate",
      align: "right",
      key: "browser_page_view_rate",
    },
    {
      title: "Ordered Product Sales ($)",
      dataIndex: "ordered_product_sales",
      key: "ordered_product_sales",
      align: "right",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
    {
      title: "Ordered Product Sales B2B ($)",
      dataIndex: "ordered_product_sales_b2b",
      key: "ordered_product_sales_b2b",
      align: "right",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
    {
      title: "Units Ordered",
      dataIndex: "units_ordered",
      key: "units_ordered",
      align: "right",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Units Ordered B2B",
      dataIndex: "units_ordered_b2b",
      key: "units_ordered_b2b",
      align: "right",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Total Order Items",
      dataIndex: "total_order_items",
      key: "total_order_items",
      align: "right",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Total Order Items B2B",
      dataIndex: "total_order_items_b2b",
      key: "total_order_items_b2b",
      align: "right",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Browser Sessions",
      dataIndex: "browser_sessions",
      key: "browser_sessions",
      align: "right",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Browser Sessions B2B",
      dataIndex: "browser_sessions_b2b",
      key: "browser_sessions_b2b",
      align: "right",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Mobile App Sessions",
      dataIndex: "mobile_app_sessions",
      key: "mobile_app_sessions",
      align: "right",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Mobile App Sessions B2B",
      dataIndex: "mobile_app_sessions_b2b",
      key: "mobile_app_sessions_b2b",
      align: "right",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Sessions",
      dataIndex: "sessions",
      key: "sessions",
      align: "right",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Sessions B2B",
      dataIndex: "sessions_b2b",
      key: "sessions_b2b",
      align: "right",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Browser Session %",
      dataIndex: "browser_session_percentage",
      key: "browser_session_percentage",
      align: "right",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
    {
      title: "Browser Session Percentage B2B",
      dataIndex: "browser_session_percentage_b2b",
      key: "browser_session_percentage_b2b",
      align: "right",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
    {
      title: "Mobile App Session %",
      dataIndex: "mobile_app_session_percentage",
      key: "mobile_app_session_percentage",
      align: "right",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
    {
      title: "Mobile App Session % B2B",
      dataIndex: "mobile_app_session_percentage_b2b",
      key: "mobile_app_session_percentage_b2b",
      align: "right",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
    {
      title: "Session %",
      dataIndex: "session_percentage",
      key: "session_percentage",
      align: "right",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
    {
      title: "Session % B2B",
      dataIndex: "session_percentage_b2b",
      key: "session_percentage_b2b",
      align: "right",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
    {
      title: "Browser Page Views",
      dataIndex: "browser_page_views",
      key: "browser_page_views",
      align: "right",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Browser Page Views B2B",
      dataIndex: "browser_page_views_b2b",
      key: "browser_page_views_b2b",
      align: "right",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Mobile App Page Views",
      dataIndex: "mobile_app_page_views",
      key: "mobile_app_page_views",
      align: "right",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Mobile App Page Views B2B",
      dataIndex: "mobile_app_page_views_b2b",
      key: "mobile_app_page_views_b2b",
      align: "right",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Page Views",
      dataIndex: "page_views",
      key: "page_views",
      align: "right",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Page Views B2B",
      dataIndex: "page_views_b2b",
      key: "page_views_b2b",
      align: "right",
      render: (e) => {
        return Comma(e);
      },
    },
    {
      title: "Browser Page Views %",
      dataIndex: "browser_page_views_percentage",
      key: "browser_page_views_percentage",
      align: "right",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
    {
      title: "Browser Page Views % B2B",
      dataIndex: "browser_page_views_percentage_b2b",
      key: "browser_page_views_percentage_b2b",
      align: "right",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
    {
      title: "Mobile App Page Views %",
      dataIndex: "mobile_app_page_views_percentage",
      key: "mobile_app_page_views_percentage",
      align: "right",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
    {
      title: "Mobile App Page Views % B2B",
      dataIndex: "mobile_app_page_views_percentage_b2b",
      key: "mobile_app_page_views_percentage_b2b",
      align: "right",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
    {
      title: "Page View %",
      dataIndex: "page_view_percentage",
      key: "page_view_percentage",
      align: "right",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
    {
      title: "Page View % B2B",
      dataIndex: "page_view_percentage_b2b",
      key: "page_view_percentage_b2b",
      align: "right",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
    {
      title: "Buy Box %",
      dataIndex: "buy_box_percentage",
      key: "buy_box_percentage",
      align: "right",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
    {
      title: "Buy Box % B2B",
      dataIndex: "buy_box_percentage_b2b",
      key: "buy_box_percentage_b2b",
      align: "right",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
    {
      title: "Unit Session %",
      dataIndex: "unit_session_percentage",
      key: "unit_session_percentage",
      align: "right",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
    {
      title: "Unit Session % B2B",
      dataIndex: "unit_session_percentage_b2b",
      key: "unit_session_percentage_b2b",
      align: "right",
      render: (e) => {
        return CommaAndFloat(e);
      },
    },
    {
      title: "Marketplace ID",
      dataIndex: "marketplace_id",
      key: "marketplace_id",
    },
  ];

  const presetRanges_ = [
    {
      label: "Yesterday",
      value: [dayjs().subtract(1, "day"), dayjs().subtract(1, "day")],
    },
    { label: "This Week", value: [dayjs().startOf("week"), dayjs()] },
    {
      label: "This Month",
      value: [dayjs().startOf("month"), dayjs().endOf("month")],
    },
    {
      label: "Last Month",
      value: [
        dayjs().subtract(1, "month").startOf("month"),
        dayjs().subtract(1, "month").endOf("month"),
      ],
    },
    {
      label: "This Quarter",
      value: [dayjs().startOf("quarter"), dayjs().endOf("quarter")],
    },
    {
      label: "This Year",
      value: [dayjs().startOf("year"), dayjs().endOf("year")],
    },
    {
      label: "Last Year",
      value: [
        dayjs().subtract(1, "year").startOf("year"),
        dayjs().subtract(1, "year").endOf("year"),
      ],
    },
  ];
  const presetRanges = presetRanges_.map((range) => {
    const start = range.value[0];
    let end = range.value[1];

    // Check if the end date is in the future
    if (end.isAfter(dayjs())) {
      end = dayjs(); // Replace with the current date
    }

    return {
      ...range,
      value: [start, end],
    };
  });
  const getList = async (data) => {
    setTableLoading(true);
    const response = await MakeApiCall(
      `report/sales-and-traffic?page=${data?.page || page || 1}&per-page=${
        data?.pageSize || pageSize
      }&field_name=${data?.field_name || ""}&sort_by=${
        data?.sort_by || ""
      }&is_export=0&search_key=${data?.search_key || ""}&start_date=${
        data?.start_date || ""
      }&end_date=${data?.end_date || ""}`,
      "get",
      null,
      true
    );

    if (response?.status) {
      setList(response?.data?.records || []);
      setTableLoading(false);
      setTotalPage(response?.data?.pagination?.totalCount || 0);
      setLoading(false);
    } else {
      setTotalPage(0);
      setTableLoading(false);
      setLoading(false);
      ErrorModal(response?.message);
    }
  };

  useEffect(() => {
    setLoading(true);
    getList({ ...filters, ...sortFilters });
    return () => {};
  }, []);

  const sortType = {
    descend: "desc",
    ascend: "asc",
  };
  const DefaultSortType = {
    desc: "descend",
    asc: "ascend",
  };
  const PropsFilter = (type) => ({
    defaultSortOrder:
      type === sortFilters?.field_name
        ? DefaultSortType?.[sortFilters?.sort_by]
        : [],
    sorter: () => {},
  });
  const handleChange = (_, __, sorter) => {
    const obj = {
      field_name: sortType?.[sorter?.order] ? sorter?.columnKey : "",
      sort_by: sortType?.[sorter?.order] || "",
    };
    setSortFilters(obj);
    getList({ ...obj, ...filters });
  };
  return (
    <div className="card custom-ui">
      <div className="card-header">
        <div className="card-title">
          ASIN Performance
          <InfoVideo
            data={locationData}
            title={"asin_performance"}
            className={"ms-3"}
          />
          <Input
            onPressEnter={() => {
              getList({
                ...filters,
                ...sortFilters,
              });
            }}
            value={filters?.search_key}
            allowClear
            onChange={(e) => {
              setFilters((prev) => {
                if (!e.target.value && prev) {
                  getList({
                    ...{
                      ...prev,
                      search_key: e.target.value,
                    },
                    ...sortFilters,
                  });
                }
                return {
                  ...prev,
                  search_key: e.target.value,
                };
              });
            }}
            placeholder="Search by parent asin, child asin, sku"
            className="w-175px ms-3"
          />
          <button
            onClick={() => {
              getList({
                ...filters,
                ...sortFilters,
              });
            }}
            className="btn btn-sm ms-3 btn-search"
            style={{ padding: "5px 15px" }}
          >
            <svg
              width={15}
              height={15}
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeWidth={2}
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="m21 21-2.243-2.247-2.243-2.247" />
              <path d="M19 10.5a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0Z" />
            </svg>
          </button>
        </div>
        <div className="card-toolbar">
          <DatePicker.RangePicker
            allowClear
            presets={presetRanges}
            value={
              filters?.start_date && filters?.end_date
                ? [
                    dayjs(filters?.start_date, "YYYY-MM-DD"),
                    dayjs(filters?.end_date, "YYYY-MM-DD"),
                  ]
                : []
            }
            disabledDate={(current) => {
              return current && current > moment().endOf("day");
            }}
            onChange={(e) => {
              const obj = {
                ...filters,
                start_date: !e ? null : dayjs(e?.[0])?.format("YYYY-MM-DD"),
                end_date: !e ? null : dayjs(e?.[1])?.format("YYYY-MM-DD"),
              };
              setFilters(obj);
              getList({ ...obj, ...sortFilters });
            }}
            className="w-250px me-3"
          />
          <ExportFile
            paramsBody={{
              source_type: "Data Source",
              record_type: "ASIN Performance",
              start_date: filters?.start_date,
              end_date: filters?.end_date,
              param_filter: {
                start_date: filters?.start_date,
                end_date: filters?.end_date,
                search_key: filters?.search_key,
              },
            }}
            title="ASIN Performance"
            hideTooltip={filters?.start_date && filters?.end_date}
            api={`report/sales-and-traffic?start_date=${
              filters?.start_date || ""
            }&end_date=${filters?.end_date || ""}&is_export=1&field_name=${
              sortFilters?.field_name || ""
            }&sort_by=${sortFilters?.sort_by || ""}&search_key=${
              filters?.search_key || ""
            }`}
          />
        </div>
      </div>
      <div className="card-body  pt-0">
        {loading ? (
          <TableLoading
            id="test-table"
            columns={[1, 2, 3, 4, 5]}
            checkBoxVal={true}
            actions={[1, 2]}
          />
        ) : list?.length === 0 ? (
          <Empty style={{ minHeight: "500px" }} />
        ) : (
          <div className="">
            <Table
              dataSource={list}
              fixed={true}
              sticky={{
                offsetHeader: "0px",
              }}
              scroll={{ x: "max-content", y: "calc(100vh - 405px)" }}
              columns={columns?.map((d) => ({
                ...d,
                className: "minWidth-table",
                ...PropsFilter(d?.dataIndex),
                render: (props, row, index) =>
                  RenderTable(props, row, index, d),
              }))}
              loading={tableLoading}
              pagination={false}
              onChange={handleChange}
              rowClassName={(record, index) => {
                return index % 2 === 0 ? "even-row" : "odd-row";
              }}
              bordered
              size="small"
            />
          </div>
        )}
        <Pagination
          loading={loading}
          pageSize={pageSize}
          page={page}
          totalPage={totalPage}
          onPerPage={(e) => {
            setLoading(true);
            setPageSize(e);
            setPage(1);
            getList({
              page: 1,
              pageSize: e,
              ...sortFilters,
              ...filters,
            });
          }}
          onPageNo={(e) => {
            setLoading(true);
            setPage(e);
            getList({
              page: e,
              ...sortFilters,
              ...filters,
            });
          }}
        />
      </div>
    </div>
  );
};

export default AsinPerformance;
